module.exports = __webpack_public_path__ + "static/Map-cfe19595e9fb65ff130326d52c31e1f5.png";